import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-beb246ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-20 p-sm-25 p-md-30 p-lg-35 letter-spacing" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-16 text-uppercase fw-medium text-dark-emphasis" }, " Triple System Analytics Data ", -1))
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1))
const _hoisted_7 = {
  class: "dropdown-menu dropdown-menu-end",
  ref: "dropdownMenu"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_10 = { class: "d-flex justify-content-between mb-3" }
const _hoisted_11 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Column Toggle"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "btncheck1"
}, "Total Score", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "btncheck2"
}, "Normalised Score", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "btncheck3"
}, "Score Rating", -1))
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = {
  class: "btn btn-outline-primary dropdown-toggle",
  type: "button",
  id: "pageSizeDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_17 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "pageSizeDropdown"
}
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = {
  class: "table table-striped table-hover",
  id: "tripleSystemAnalyticsTable"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "System 1", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "System 2", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "System 3", -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  "aria-label": "Page navigation example",
  class: "mt-3"
}
const _hoisted_30 = { class: "pagination" }
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTable('jpg')))
              }, [
                _hoisted_8,
                _createTextVNode(" Export as JPG ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportTable('png')))
              }, [
                _hoisted_9,
                _createTextVNode(" Export as PNG ")
              ])
            ])
          ], 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck1",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTotalScore) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showTotalScore]
          ]),
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck2",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showNormalisedScore) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showNormalisedScore]
          ]),
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck3",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showScoreRating) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showScoreRating]
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", _hoisted_16, " Page Size: " + _toDisplayString(_ctx.itemsPerPage), 1),
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.setPageSize(10)), ["prevent"]))
              }, "10")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.setPageSize(25)), ["prevent"]))
              }, "25")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.setPageSize(50)), ["prevent"]))
              }, "50")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.setPageSize(100)), ["prevent"]))
              }, "100")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("table", _hoisted_19, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              (_ctx.showTotalScore)
                ? (_openBlock(), _createElementBlock("th", _hoisted_23, "Total Score"))
                : _createCommentVNode("", true),
              (_ctx.showNormalisedScore)
                ? (_openBlock(), _createElementBlock("th", _hoisted_24, "Normalised Score"))
                : _createCommentVNode("", true),
              (_ctx.showScoreRating)
                ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Score Rating"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({ 'table-row-striped': index % 2 === 1 })
              }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.formatCamelCase(item.System1)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatCamelCase(item.System2)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatCamelCase(item.System3)), 1),
                (_ctx.showTotalScore)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(item.TotalScore), 1))
                  : _createCommentVNode("", true),
                (_ctx.showNormalisedScore)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(_ctx.formatNormalisedScore(item.NormalisedScore)), 1))
                  : _createCommentVNode("", true),
                (_ctx.showScoreRating)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.getAlertClass(item.NormalisedScore)),
                        role: "alert"
                      }, _toDisplayString(_ctx.getRating(item.NormalisedScore)), 3)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_29, [
        _createElementVNode("ul", _hoisted_30, [
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
          }, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
            }, "Previous")
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }]),
              key: page
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
              }, _toDisplayString(page), 9, _hoisted_31)
            ], 2))
          }), 128)),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
          }, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
            }, "Next")
          ], 2)
        ])
      ])
    ])
  ]))
}